import { useEffect, useState } from 'react';
import { Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, InputLabel, MenuItem, Select, TextField, Typography, Icon } from '@mui/material';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AptaTable from 'examples/AptaTable';
import MDTypography from 'components/MDTypography';
import { SERVER_URL } from 'constants/constant';
import Swal from 'sweetalert2';


const Judges = () => {
    const [judges, setJudges] = useState([]);
    const [details, setDetails] = useState({ name: "", email: "", phoneNumber: "", password: "", memShipId: "", hospitalName: "" });
    const [open, setOpen] = useState(false);
    const [roleType, setRoleType] = useState('add');

    useEffect(() => {
        fetchJudges();
    }, []);

    const fetchJudges = async () => {
        const response = await fetch(`${SERVER_URL}/get-all-judges`);
        const data = await response.json();
        setJudges(data?.judges);
    };

    const handleSave = async (data) => {
        try {
            let response;
            if (roleType === 'add') {
                response = await fetch(`${SERVER_URL}/create-judge`, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                });
            } else {

                response = await fetch(`${SERVER_URL}/judge/update/${data._id}`, {
                    method: 'PUT',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(data),
                });
            }

            if (response.ok) {
                Swal.fire({ icon: 'success', text: roleType === 'add' ? "Successfully created!" : "Successfully edited!" });
            } else {
                const errorMessage = await response.text();
                Swal.fire({ icon: 'error', text: errorMessage?.message || "Please try again!" });
            }
        } catch (error) {
            console.log(error);
            Swal.fire({ icon: 'error', text: "hi" });
        } finally {
            setOpen(false);
            fetchJudges();
        }
    };


    const handleDelete = async (id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "This will delete the judge permanently.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, delete it!",
        }).then(async (result) => {
            if (result.isConfirmed) {
                await fetch(`${SERVER_URL}/delete/${id}`, { method: 'DELETE' });
                fetchJudges();
            }
        });
    };

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <Box display={'flex'} mb={3} justifyContent={'end'}>
                <Button startIcon={<Icon>add</Icon>} style={{ color: 'white' }} variant='contained' color='primary'
                    onClick={() => { setRoleType('add'); setDetails({ name: "", email: "", phoneNumber: "", password: "", memShipId: "", hospitalName: "" }); setOpen(true); }}>
                    Add Judge
                </Button>
            </Box>
            <AptaTable
                columns={['name', 'mobile', 'email', 'Hospital', 'MembershipId', 'Login Date', 'actions']}
                rows={judges?.map((item) => ({
                    name: item?.name,
                    mobile: item?.phoneNumber,
                    email: item?.email,
                    Hospital: item?.hospitalName,
                    "MembershipId": item?.memShipId,
                    'Login Date': item?.lastLogin?.slice(0, 10),
                    actions: (
                        <ButtonGroup size='small'>
                            <Button color='info' style={{ color: '#2196f3' }} onClick={() => { setRoleType('edit'); setDetails(item); setOpen(true); }}>
                                <Icon>edit</Icon>
                            </Button>
                            <Button style={{ color: 'red' }} color='error' onClick={() => handleDelete(item?._id)}>
                                <Icon>delete</Icon>
                            </Button>
                        </ButtonGroup>
                    )
                }))}
            />
            <InputFormModal open={open} onClose={() => setOpen(false)} onSave={handleSave} details={details} type={roleType} />
        </DashboardLayout>
    );
};

export default Judges;

const InputFormModal = ({ open, onClose, onSave, details, type }) => {
    const [formData, setFormData] = useState(details);

    useEffect(() => {
        setFormData(details);
    }, [details]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{type === 'add' ? 'Add Judge' : 'Edit Judge'}</DialogTitle>
            <DialogContent>
                <TextField label="Name" name="name" value={formData.name} onChange={handleChange} fullWidth margin="normal" />
                <TextField label="Email" name="email" value={formData.email} onChange={handleChange} fullWidth margin="normal" />
                <TextField label="Mobile" name="phoneNumber" value={formData.mobile} onChange={handleChange} fullWidth margin="normal" />
                <TextField label="Hospital Name" name="hospitalName" value={formData.hospitalName} onChange={handleChange} fullWidth margin="normal" />
                <TextField label="Membership Id" name="memShipId" value={formData.memShipId} onChange={handleChange} fullWidth margin="normal" />

                {type === 'add' && (
                    <TextField label="Password" name="password" type="password" value={formData.password} onChange={handleChange} fullWidth margin="normal" />
                )}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Cancel</Button>
                <Button
                    onClick={() => onSave(formData)}
                    variant="contained"
                    color="primary"
                    style={{ color: 'white' }}
                    disabled={
                        formData?.name?.trim() === "" ||
                        formData?.email?.trim() === "" ||
                        formData?.mobile?.trim() === "" ||
                        (type === 'add' && formData.password.trim() === "")
                    }
                >
                    Save
                </Button>
            </DialogActions>
        </Dialog>

    );
};